module.exports = __webpack_public_path__ + "06.svg?261ae61f58965452349824496157c3ce";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_setting/06.svg
// module id = 65
// module chunks = 0